import React, { useContext, useEffect, useState } from "react"
import { PriceContext } from "../../PriceContext"
import * as style from "../../newStyles.module.scss"
import { TariffKey } from "./types"

interface TotalPriceProps {
  tariff: TariffKey
}

const formatPrice = (options: Record<string, { price?: number }> | null | undefined, range: string, discount: number, addonsPrice: number) => {
  if (!options?.[range]) return 0

  const price = Math.ceil((options[range].price ?? 0) * discount + addonsPrice)

  return price.toLocaleString("ru-RU")
}

const TotalPrice: React.FC<TotalPriceProps> = ({ tariff }) => {
  const { calculator, range, discount, addons, text } = useContext(PriceContext)
  const [scrolledPastExpert, setScrolledPastExpert] = useState(false)

  const plansMap = {
    Core: calculator.plans?.core,
    Support: calculator.plans?.support,
    Marketing: calculator.plans?.marketing,
    MarketingExpert: calculator.plans?.marketingExpert,
    EnterpriseMarketing: calculator.plans?.enterpriseMarketing,
    EnterpriseSupport: calculator.plans?.enterpriseSupport,
  }

  const addonsMap = {
    Core: addons.core,
    Support: addons.support,
    Marketing: addons.marketing,
    MarketingExpert: addons.marketingExpert,
    EnterpriseMarketing: addons.enterpriseMarketing,
    EnterpriseSupport: addons.enterpriseSupport,
  }

  const options = plansMap[tariff] ?? null
  const addonsPrice = addonsMap[tariff] ?? 0

  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById("marketingExpert")

      if (!element) return

      const rect = element.getBoundingClientRect()
      setScrolledPastExpert(rect.bottom < 120)
    }

    window.addEventListener("scroll", handleScroll)
    handleScroll()

    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const currentPrice = options?.[range]?.price ?? 0

  if (currentPrice <= 0) {
    return (
      <p className={style.totalPriceRequest}>
        <span dangerouslySetInnerHTML={{ __html: text.addonText.request }} />
      </p>
    )
  }

  return (
    <div className={`${style.totalPrice} ${scrolledPastExpert ? "" : ""}`}>
      <p className={style.totalPriceCount}>
        {formatPrice(options, range, discount, addonsPrice)}
        <span dangerouslySetInnerHTML={{ __html: text.addonText.rub }} />
      </p>

      <div className={`${scrolledPastExpert ? "" : ""}`}>
        {discount < 1 && (
          <span className={style.totalPriceOld}>
            {formatPrice(options, range, 1, addonsPrice)}
            <span dangerouslySetInnerHTML={{ __html: text.addonText.rub }} />
          </span>
        )}

        <span dangerouslySetInnerHTML={{ __html: text.addonText.after }} />
      </div>
    </div>
  )
}

export default TotalPrice
